import { ContentText } from '../../global-types/AdvisoryContent';
import './PriceSummaryCard.css';

type PriceSummaryCardProps = {
  texts: ContentText[];
};

function PriceSummaryCard({ texts }: PriceSummaryCardProps) {
  return (
    <div id="advisory-price-summary" className="if card elevated advisory-mb-16">
      <div className="if card-content">
        <div className="card-row">
          <span className={`if typography ${texts[0].classNames}`}>
            {texts[0].value}
          </span>
          <span className={`if typography ${texts[1].classNames}`}>
            {texts[1].value}
          </span>
        </div>
        <div className="card-row">
          <span className={`if typography ${texts[2].classNames}`}>
            {texts[2].value}
          </span>
          <span className={`if typography ${texts[3].classNames}`}>
            {texts[3].value}
          </span>
        </div>
        <hr />
        <div className="card-row total-row">
          <span className={`if typography ${texts[4].classNames}`}>
            {texts[4].value}
          </span>
          <span className={`if typography ${texts[5].classNames}`}>
            {texts[5].value}
          </span>
        </div>
        <span className={`if typography ${texts[6].classNames}`}>
          {texts[6].value}
        </span>
      </div>
    </div>
  );
};

export default PriceSummaryCard;
